// eslint-disable-next-line import/prefer-default-export
export const ACTION_TYPES = {
  CREATE_FAVORITE_PRODUCT: 'FAVORITE/CREATE_FAVORITE_PRODUCT',
  DELETE_FAVORITE_PRODUCT: 'FAVORITE/DELETE_FAVORITE_PRODUCT',
}
